import {Alert, Button, message, Upload,} from 'antd'
import {getId, getType,} from 'apis/model/base'
import {handleconfirm} from 'components/Confirm'
import Toggle from 'components/Toggle'
import copyToClipboard from 'copy-to-clipboard'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import React, {useContext, useState,} from 'react'
import {IoCloudUploadOutline,} from 'react-icons/io5'
import {AcceptFileTypes} from 'views/Messages/DragDropFile'
import NoFoundPage from 'views/NoFoundPage'
import {NullAsDefault, renderOwnChild,} from 'views/Shared'
import {bindQueryParam} from '../functions/routerHelper'
import {notifyOnError} from './createErrorEvent'
import CourseContext, {CourseProvider} from "../Course/CourseContext";
import {
    course_doCourseAttendanceImportFile_Api,
    course_doCourseGradeImportFile_Api,
    course_doCourseStudentImportFile_Api
} from "../../../apis";
import {PiShootingStarDuotone} from "react-icons/pi";
import {RxCopy} from "react-icons/rx";
import {renderIf, renderIfElse} from "../../Shared";
import {BiHelpCircle} from "react-icons/bi";
import TooltipApp from "../../../components/TooltipApp";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import {renderFromToTime} from "../../../helpers/datetimeHelpers";
import LoadingBlock from "../../Loading/LoadingBlock";

const course_student_template_url =
    'https://docs.google.com/spreadsheets/d/17_Y7P1oTndoY0nG8sRmdYXx-wtUAT0cwpW62SkswFiY/edit?usp=sharing'
const course_attendance_template_url =
    'https://docs.google.com/spreadsheets/d/1dQmHNJpdspoQhJGxKZBzuXuKrXhV14zZx-oVQ8Co0FQ/edit?usp=sharing'
const course_grade_template_url =
    'https://docs.google.com/spreadsheets/d/1_9MQM6x2GHVkFKH5IGy2HA2QnUfEADBPh1M9t-RDgIU/edit?usp=sharing'

const renderSelectedFile = (file) => (
    <Translate>
        {(t) =>
            file ? (
                <div className="flex flex-col items-center">
                    <IoCloudUploadOutline size={40} className="text-primary"/>
                    <span className="text-xs font-medium text-color-100">
            {file.name} {' - '}
                        <span className="text-color-000 italic">
              {(file.size / 1024)
                  .toFixed(2)
                  .toLocaleString()}
                            {' kB'}
            </span>
          </span>
                </div>
            ) : (
                <div className="flex flex-col items-center">
                    <IoCloudUploadOutline size={40} style={{color: '#e0e0e0'}}/>
                    <span className="font-medium text-xs text-color-200">
            {t('click to upload')}
          </span>
                </div>
            )
        }
    </Translate>
)

const ItemNotes = ({
                       sheet,
                       name,
                       primary = false,
                       label,
                       column,
                       optional = false,
                       noted = false,
                       HelperComponent = NullAsDefault,
                   }) => (
    <Translate>
        {(t) => (
            <div className="space-x-1 text-xs">
                {renderIf(
                    sheet,
                    <span className="text-color-000 font-bold">
              {`${t('sheet')} "${t(sheet)}"`}
            </span>
                )}
                {renderIf(
                    column,
                    <span className="text-primary font-bold">
              {`${column} - `}
            </span>
                )}
                {renderIf(
                    name,
                    <span className="text-color-200 font-bold">
              {name}
            </span>
                )}
                {renderIf(
                    primary === true,
                    <span className="text-primary">
              {'*'}
            </span>
                )}
                <span className="text-color-400 italic font-light">
          {` : ${t(label)}`}
        </span>

                {renderIf(
                    optional === true,
                    <span className="text-color-400 italic font-light">
              {`(${t('optional')})`}
            </span>
                )}

                <HelperComponent/>
                {renderIf(
                    noted === true,
                    <PiShootingStarDuotone className="text-primary-500"/>
                )}
            </div>
        )}
    </Translate>
)

const DescriptionTemplate = ({
                                 inputHelpers = [],
                                 notedDescription,
                             }) => {
    const t = useTranslate()

    const noted = _.find(Array.from(inputHelpers), ['noted', true])
    return (
        <Toggle>
            {(isToggle, toggle) => (
                <div className="flex flex-col px-2 md:px-3 py-2 border rounded-lg border-dashed">
                    <div className="space-y-1">
            <span className="text-xs italic text-color-300 underline">
              {`${t('Description of the input file structure')} : `}
            </span>
                        <div className="space-y-1 pl-0 md:pl-3">
                            {Array.from(inputHelpers).filter((e) => isToggle || !!!e.optional)
                                .map((e, i) => (
                                    <ItemNotes key={i} {...e} />
                                ))}
                        </div>
                    </div>
                    <div className="my-2 flex justify-end gap-2">
            <span
                onClick={toggle}
                className="text-xs text-color-400 hover:text-color-100 italic leading-tight cursor-pointer">
              {isToggle ? `${t('see less')} ...` : `... ${t('see more')}`}
            </span>
                    </div>

                    {renderIf(
                        noted,
                        <span className="space-x-1 text-xs text-color-500 italic leading-snug">
                <PiShootingStarDuotone className="text-primary-500"/>
                <span className="font-medium text-color-100">
                  {`- ${t('note')} : `}
                </span>
                <span>{t(notedDescription)}</span>
              </span>
                    )}

                </div>
            )}
        </Toggle>
    )
}

const ImportModalContent = ({
                                title,
                                item,
                                query,
                                values,
                                apiInfo,
                                onCancel = NullAsDefault,
                                maxSize = 2048000,
                                Description = NullAsDefault,
                                templateUrlPath = '',
                                Wrapper = renderOwnChild,
                            }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const {handleGoBack = NullAsDefault} = useContext(NavigationContext)

    const [isInValid, setInvalid] = useState()

    const [file, setFile] = useState()

    const handleFile = (file) => {
        const {name, size, ...rest} =
        file || {}
        setInvalid(size > maxSize)
        if (size > maxSize) {
            message.error(
                <div className="flex gap-3">
          <span className="text-color-300 font-light text-sm italic">
            {t('current size')} {' : '}
              <span className="font-medium text-color-000">
              {Math.round(size / 1024)} {' MB'}
            </span>
          </span>
                    <span className="text-color-300 font-light text-sm italic">
            {t('max size')} {' : '}
                        <span className="font-medium text-color-000">
              {Math.round(maxSize / 1024)} {' MB'}
            </span>
          </span>
                </div>
            )
        } else {
            setFile(file)
        }
    }

    const {
        isLoading = false,
        handleAsyncAction,
    } = useAsyncAction({
        query,
        values,
        apiInfo,
        onError: notifyOnError(t),
        onSuccess: (__, data) => {
            const {total = 0, success = 0} =
                _.get(data, 'response.data', {})
            handleconfirm({
                title: t('upload file'),
                okText: t('OK'),
                cancelText: t('cancel'),
                okButtonProps: {
                    type: 'primary',
                    className:
                        'rounded-lg no-shadow no-text-shadow',
                },
                cancelButtonProps: {
                    className:
                        'rounded-lg no-shadow no-text-shadow',
                },
                onOk: () => {
                    // handleGoBack()
                    onCancel()
                },
                content: (
                    <Alert
                        type="success"
                        className="background border-green-600"
                        message={
                            <div
                                className="flex flex-row items-center py-1"
                                role="alert">
                                <div className="flex flex-col text-sm">
                  <span className="text-color-300 font-light italic">
                    {t('total row')}{' '}
                      {' : '}
                      <span className="font-medium text-color-000">
                      {total} {t('row')}
                    </span>
                  </span>
                                    <span className="text-color-300 font-light italic">
                    {t('success row')}{' '}
                                        {' : '}
                                        <span className="font-medium text-green-700">
                      {success}{' '}
                                            {t('row')}
                    </span>
                  </span>
                                </div>
                            </div>
                        }
                    />
                ),
            })
        },
    })

    const {time_open, time_close} = item ?? {}

    if (!item || _.isEmpty(item)) {
        return <NoFoundPage/>
    }

    return (
        <Wrapper>
            <div className="flex flex-col w-full space-y-4">
                <div className="flex flex-col gap-2">
          <span className="text-color-300 uppercase font-medium">
            {`${t('you are importing')} `}
              {renderIfElse(title, t(title), t(getType(item)))}
          </span>
                    <div className="background border border-color-50 shadow-items-md px-3 py-2 rounded-md">
                        <div className="flex flex-col gap-1 flex-1">
              <span className="font-bold text-color-000">
                {getTitle(item)}
              </span>
                            {renderIf(
                                _.get(item, 'owner.title'),
                                <span className="font-bold text-primary text-xs italic">
                    <span className="font-normal text-color-500 mr-1">
                      {t('organized by')}
                    </span>
                                    {_.get(item, 'owner.title')}
                  </span>
                            )}
                            {renderIf(
                                _.some([time_open, time_close]),
                                <span className="font-bold text-color-100 text-xs italic">
                    <span className="font-normal text-color-500 mr-1">
                      {`${t('time takes place')} : `}
                    </span>
                                    {renderFromToTime(_.get(item, 'time_open'), _.get(item, 'time_close'))}
                  </span>
                            )}
                        </div>
                    </div>
                </div>
                <div className="w-full custom-upload-file">
                    <style>
                        {`
              .ant-upload.ant-upload-drag {
                border-radius: 0.375rem;
                background: #fafafa;
                border-color: var(--border-color-base);
              }
              .ant-upload.ant-upload-drag:hover {
                background: #ebf8ff;
                border-color: #63b3ed !important;
              }
            `}
                    </style>
                    <Upload.Dragger
                        name="file"
                        style={{borderColor: file && 'var(--color-primary)'}}
                        accept={[
                            AcceptFileTypes.XSL,
                            AcceptFileTypes.XSL_APP,
                            AcceptFileTypes.XSLX_APP,
                        ].join(',')}
                        onDrop={(event) => {
                            handleFile(_.get(event, 'dataTransfer.files[0]'))
                        }}
                        showUploadList={false}
                        beforeUpload={(file) => {
                            handleFile(file)
                            return false
                        }}>
                        {renderSelectedFile(file)}
                        <span className="text-2xs text-color-500 italic">
              {`${t('limit description')} : `}
                            <span className="font-semibold text-color-100 ml-1">
                {'2MB'}
              </span>
            </span>
                    </Upload.Dragger>
                </div>

                <div className="flex flex-col gap-1">
          <span className="text-color-300 uppercase font-medium">
            {t('template data')}
          </span>
                    <div className="flex items-center gap-2">
                        <a
                            style={{height: 32, padding: 6}}
                            target="_blank"
                            className="text-xs italic text-color-300 truncate px-2 border background rounded-md no-underline"
                            rel="noopener noreferrer"
                            href={templateUrlPath}>
                            {templateUrlPath}
                        </a>
                        <Button
                            onClick={() => {
                                copyToClipboard(
                                    templateUrlPath
                                )
                            }}
                            className="button-rounded-md flex flex-center text-color-300 hover:text-primary px-3 py-2"
                            type="dashed">
                            <RxCopy/>
                        </Button>
                        <Button
                            className="no-shadow no-text-shadow rounded-md no-border"
                            type="primary">
                            <a
                                target="_blank"
                                className="no-underline"
                                rel="noopener noreferrer"
                                href={templateUrlPath}>
                                {isSm ? t('view sample') : t('preview template')}
                            </a>
                        </Button>
                    </div>
                </div>

                <Description/>

                <div className="flex justify-end gap-2">
                    <NavigationContext.Consumer>
                        {({
                              handleGoBack = NullAsDefault,
                          }) => (
                            <Button
                                className="no-shadow no-text-shadow rounded-lg no-border"
                                onClick={() => {
                                    handleGoBack()
                                    onCancel()
                                }}>
                                {t('close')}
                            </Button>
                        )}
                    </NavigationContext.Consumer>
                    <Button
                        type="primary"
                        loading={!!isLoading}
                        className="no-shadow no-text-shadow rounded-lg no-border"
                        disabled={
                            !!isLoading || !file
                        }
                        onClick={() => {
                            handleAsyncAction({
                                file,
                            })
                        }}>
                        {t('import')}
                    </Button>
                </div>
            </div>
        </Wrapper>
    )
}

const courseStudentDescriptions = [
    {
        column: 'A',
        name: 'PATRON_SAINT',
        label: 'holy name',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('prefix title description')}. `}
                                <span className="font-semibold text-secondary text-sm italic">
                  {`${t('example')} : ${t('Giuse, Maria,...')}`}
                </span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'B',
        name: 'NAME',
        label: 'full name',
        optional: false,
        // noted: true,
    },
    {
        column: 'C',
        name: 'GENDER',
        label: 'gender',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <span className="font-semibold text-secondary text-sm italic">
                        {`${t('note')} : ${t('male')}, ${t('female')}, ${t('others')}`}
                    </span>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'D',
        name: 'DATE_OF_BIRTH',
        label: "date of birth",
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <span className="font-semibold text-secondary text-sm italic">
                        {`${t('re-format')} : DD/MM/YYYY`}
                    </span>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'E',
        name: 'PLACE_OF_BIRTH',
        label: 'place of birth',
        optional: false,

    },
    {
        column: 'F',
        name: 'CONTACT_ADDRESS',
        label: 'address',
        optional: false,
    },
    {
        column: 'G',
        name: 'CONTACT_PHONE',
        label: 'phone',
        optional: false,
    },
    {
        column: 'H',
        name: 'CONTACT_EMAIL',
        label: 'email',
        optional: false,
    },
    {
        column: 'I',
        name: 'IDENTIFIER_TYPE',
        label: 'id type',
        optional: false,
    },
    {
        column: 'J',
        name: 'IDENTIFIER_CODE',
        label: 'id code',
        optional: false,
    },
    {
        column: 'K',
        name: 'STUDENT_IDCODE',
        label: 'student code',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('student code description')}.`}
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'L',
        name: 'COURSE_CLASS_IDCODE',
        label: 'course class idcode',
        optional: false,
        noted: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('course class description')}.`}
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'M',
        name: 'COURSE_STUDENT_RESULT_STATUS',
        label: 'course student result status',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('example')} : `}
                                <span className="font-light text-sm italic">
                  {`${t('passed')}, ${t('failed')}, ${t('not assessed yet')}`}
                </span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'N',
        name: 'GROUP_NAME',
        label: 'group name',
        optional: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('example')} : `}
                                {`${t('subclass title')}`}
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'O',
        name: 'DIOCESE_NAME',
        label: 'diocese',
        optional: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('example')} : `}
                                {`${t('diocese title')}`}
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },

    {
        column: 'P',
        name: 'DEANERY_NAME',
        label: 'deanery',
        optional: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('example')} : `}
                                {`${t('deanery title')}`}
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'Q',
        name: 'PARISH_NAME',
        label: 'parish',
        optional: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('example')} : `}
                                {`${t('parish title')}`}
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'R, S, T, U, V, W, X, Y, Z',
        name: 'others',
        label:
            'additional fields for information',
        optional: true,
    },
]


export const createDataImporter = (
    title,
    item,
    templateUrlPath,
    descriptions,
    query,
    apiInfo,
    params,
) => (
    <ImportModalContent
        title={title}
        item={item}
        templateUrlPath={templateUrlPath}
        query={query}
        Description={() => (
            <DescriptionTemplate
                inputHelpers={descriptions}
                notedDescription="catholic household record number description"
            />
        )}
        apiInfo={apiInfo}
        {...(params || {})}
    />
)

export const createCourseStudentImporter = (
    item,
    params
) => (
    <ImportModalContent
        title="students of the course"
        item={item}
        templateUrlPath={
            course_student_template_url
        }
        query={bindQueryParam({
            id: getId(item),
        })}
        Description={() => (
            <DescriptionTemplate
                inputHelpers={
                    courseStudentDescriptions
                }
                notedDescription="note import student description"
            />
        )}
        apiInfo={
            course_doCourseStudentImportFile_Api
        }
        {...(params || {})}
    />
)

const courseAttendanceDescriptions = [
    {
        column: 'A',
        name: 'ATTENDANCE_DATE',
        label: 'attendance date',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('re-format')} : `}
                                <span className="font-semibold text-secondary text-sm italic">
                  {'DD/MM/YYYY'}
                </span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'B',
        name: 'NAME',
        label: 'lesson',
        optional: false,
        noted: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('lesson description')}`}
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'C',
        name: 'COURSE_CLASS_IDCODE',
        label: "course class idcode",
        optional: false,
        noted: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('course class description')}.`}
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'D',
        name: 'SUBJECT_IDCODE',
        label: 'subjects',
        optional: false,
        noted: true,
    },
    {
        column: 'E',
        name: 'STUDENT_IDCODE',
        label: 'student code',
        optional: false,
    },
    {
        column: 'F',
        name: 'STUDENT_NAME',
        label: 'full name',
        optional: true,
    },
    {
        column: 'G',
        name: 'NUMBER_OF_SESSIONS',
        label: 'the number of lessons in a class session',
        optional: false,
    },
    {
        column: 'H',
        name: 'TOTAL_SESSIONS',
        label: 'total sessions',
        optional: false,
    },
    {
        column: 'I',
        name: 'ATTENDANCE_STATUS',
        label: 'attendance status',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <span className="font-semibold text-secondary text-sm italic">
                        {`${t('note')} : ${t('c: in attendance')}, ${t('p: excused absence')}, ${t('k: unexcused absence')}`}
                    </span>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'J',
        name: 'ABSENT_REASON',
        label: 'absent reason description',
        optional: false,
    },
]

export const createCourseAttendanceImporter = (
    item,
    params
) => (
    <ImportModalContent
        title="attendance for the course"
        item={item}
        templateUrlPath={
            course_attendance_template_url
        }
        query={bindQueryParam({
            id: getId(item),
        })}
        Description={() => (
            <DescriptionTemplate
                inputHelpers={
                    courseAttendanceDescriptions
                }
                notedDescription="note import attendance description"
            />
        )}
        apiInfo={
            course_doCourseAttendanceImportFile_Api
        }
        {...(params || {})}
    />
)

const courseGradeDescriptions = [
    {
        column: 'A',
        name: 'GRADE_DATE',
        label: 'grade date',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('re-format')} : `}
                                <span className="font-semibold text-secondary text-sm italic">
                  {'DD/MM/YYYY'}
                </span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'B',
        name: 'NAME',
        label: 'score column identifier',
        optional: false,
        noted: true,
    },
    {
        column: 'C',
        name: 'COURSE_CLASS_IDCODE',
        label: "course class idcode",
        optional: false,
        noted: true,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('course class description')}.`}
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'D',
        name: 'SUBJECT_IDCODE',
        label: 'subjects',
        optional: false,
        noted: true,
    },
    {
        column: 'E',
        name: 'STUDENT_IDCODE',
        label: 'student code',
        optional: false,
    },
    {
        column: 'F',
        name: 'STUDENT_NAME',
        label: 'full name',
        optional: false,
    },
    {
        column: 'G',
        name: 'SCORE_WEIGHT',
        label: 'score weight',
        optional: false,
    },
    {
        column: 'H',
        name: 'SCORE_TYPE',
        label: 'score type',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <span className="font-semibold text-secondary text-sm italic">
                      {`${t('note')} : ${t('number')}, ${t('text')}`}
                    </span>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
    {
        column: 'I',
        name: 'SCORE',
        label: 'the first grading session',
        optional: false,
    },
    {
        column: 'J',
        name: 'SCORE_1',
        label: 'the second grading session',
        optional: false,
    },
    {
        column: 'K',
        name: 'SCORE_2',
        label: 'the third grading session',
        optional: false,
    },
    {
        column: 'L',
        name: 'STUDENT_SUBJECT_RESULT_STATUS',
        label: 'student subject result status',
        optional: false,
        HelperComponent: () => (
            <Translate>
                {(t) => (
                    <TooltipApp
                        title={
                            <div>
                                {`${t('example')} : `}
                                <span className="font-light text-sm italic">
                  {`${t('passed')}, ${t('failed')}, ${t('not assessed yet')}`}
                </span>
                            </div>
                        }>
                        <BiHelpCircle size={12} className="text-color-400 hover:text-color-100 cursor-pointer"/>
                    </TooltipApp>
                )}
            </Translate>
        ),
    },
]

export const createCourseGradeImporter = (
    item,
    params
) => (
    <ImportModalContent
        title="grade for the course"
        item={item}
        templateUrlPath={
            course_grade_template_url
        }
        query={bindQueryParam({
            id: getId(item),
        })}
        Description={() => (
            <DescriptionTemplate
                inputHelpers={
                    courseGradeDescriptions
                }
                notedDescription="note import grade description"
            />
        )}
        apiInfo={
            course_doCourseGradeImportFile_Api
        }
        {...(params || {})}
    />
)


export const ImporterLoader = ({
                                   id,
                                   type,
                                   onCancel,
                               }) => {
    if (_.isEmpty(id)) {
        return null
    }
    switch (type) {
        case "COURSE_STUDENT_IMPORT":
            return (
                <CourseProvider item={id}>
                    <CourseContext.Consumer>
                        {({
                              item,
                              isLoading,
                          }) =>
                            !!isLoading ? (
                                <LoadingBlock/>
                            ) : (
                                createCourseStudentImporter(
                                    item,
                                    {onCancel}
                                )
                            )
                        }
                    </CourseContext.Consumer>
                </CourseProvider>
            )
        case "COURSE_ATTENDANCE_IMPORT":
            return (
                <CourseProvider item={id}>
                    <CourseContext.Consumer>
                        {({
                              item,
                              isLoading,
                          }) =>
                            !!isLoading ? (
                                <LoadingBlock/>
                            ) : (
                                createCourseAttendanceImporter(
                                    item,
                                    {onCancel}
                                )
                            )
                        }
                    </CourseContext.Consumer>
                </CourseProvider>
            )
        case "COURSE_GRADE_IMPORT":
            return (
                <CourseProvider item={id}>
                    <CourseContext.Consumer>
                        {({
                              item,
                              isLoading,
                          }) =>
                            !!isLoading ? (
                                <LoadingBlock/>
                            ) : (
                                createCourseGradeImporter(
                                    item,
                                    {onCancel}
                                )
                            )
                        }
                    </CourseContext.Consumer>
                </CourseProvider>
            )
        default:
            return null
    }
}
